import viewport from '~/mixins/viewport';
import { ProductAgent } from './../types';
import MyActionBtn from '~/themes/novaporta/components/ui/MyActionBtn';
import eventBus from '~/plugins/event-bus';
import { setFavorite, isProductInFavorites } from '@/themes/novaporta/utils/favorites';
import { addProductToCart } from '@/themes/novaporta/utils/cart';
import cartUpdate from '~/themes/novaporta/mixins/cart-update';

export default {
    mixins: [viewport, cartUpdate],
    props: {
        product: ProductAgent,
        analyticProducts: {}
    },
    data() {
        return {
            isInFavorites: false
        };
    },
    computed: {
        linkProduct() {
            return this.localePath(`/product/${this.product.slug}`);
        },
        isSliderActive() {
            return this.product.slides.length > 1 ? true : false;
        },
        haveImage() {
            return this.product?.img || this.firstSlideImage ? true : false;
        },
        firstSlideImage() {
            return this.product.slides[0]?.img || null;
        },
        allowCountingSetting() {
            return this.product.count === null ? false : true;
        },
        allowQuantitySetting() {
            return this.product.quantity === null ? false : true;
        },
        isValidOldPrice() {
            return this.product.oldPrice > this.product.price ? true : false;
        }
    },
    methods: {
        updateIsInFavorites() {
            if (isProductInFavorites(this.product.id)) this.isInFavorites = true;
            else this.isInFavorites = false;
        },
        extensionFullPrice(item) {
            const newPrice = item.price || 0;
            const itemMultiplicity = item.multiplicity || 1;

            return newPrice * itemMultiplicity;
        },

        triggerActionFavorites() {
            // TO DO: add or remove from favorites list

            const cleanProduct = this?.analyticProducts
                ? this?.analyticProducts?.find(item => Number(item?.productId) === Number(this?.product?.id))
                : null;
            setFavorite(cleanProduct || this.product);
            this.updateIsInFavorites();
        },
        triggerActionAddToCart() {
            // TO DO: add or increase the count of product in cart
            const cleanProduct = this?.analyticProducts
                ? this?.analyticProducts?.find(item => Number(item?.productId) === Number(this?.product?.id))
                : null;

            addProductToCart(this.product.id, [], this.product.count, [], null, this.product.slug, cleanProduct);

            eventBus.$emit('show-toast', {
                actionProp: {
                    action: () => this.$router.push(this.localePath('/cart')),
                    buttonName: this.$t('globalActionCheckCart')
                },
                closeButton: false,
                hideProgressBar: true,
                message: this.$t('globalMessageSuccessfullyAddedToCart'),
                type: 'success',
                timeout: 2000
            });
        }
    },
    components: {
        Badges: () => import('@/themes/novaporta/components/reusable/Badges'),
        MyActionBtn
    },
    mounted() {
        this.updateIsInFavorites();
    }
};
